// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 查询目录列表 GET /course/catalog/list */
export async function courseCatalogListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.courseCatalogListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListCourseCatalogResp>('/course/catalog/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 编辑浏览量 GET /course/catalog/updateVisitCount */
export async function courseCatalogUpdateVisitCountUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.courseCatalogUpdateVisitCountUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/course/catalog/updateVisitCount', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
